import { Directive, ElementRef, HostListener, inject } from '@angular/core';

/**
 * Opt-in number-input UX guard. Apply via the `cmtNoNumberStep` attribute on
 * `<input type="number">`:
 *
 *   <input hlmInput cmtNoNumberStep type="number" min="0" step="0.01" />
 *
 * Two effects:
 * 1. Hides native ± spinner arrows (via the `cmt-no-number-step` host class
 *    — see styles.tailwind.css for the vendor-pseudo-element rules).
 * 2. Blurs the input on `wheel` so a stray scroll over a focused field
 *    doesn't silently mutate the value (Chrome's default). The wheel event
 *    still propagates, so the page scrolls as the user expected.
 *
 * Scoped to consumers that explicitly opt in — the design-system primitive
 * (HlmInputDirective) does not enforce this, so legacy or finance-heavy
 * forms can keep native steppers if they prefer.
 */
@Directive({
  selector: 'input[cmtNoNumberStep]',
  standalone: true,
  host: { class: 'cmt-no-number-step' },
})
export class CmtNoNumberStepDirective {
  private readonly host = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener('wheel') onWheel(): void {
    const el = this.host.nativeElement;
    if (el.type === 'number' && document.activeElement === el) {
      el.blur();
    }
  }
}
